export { default as Img200 } from './processed/200/Succession-S1.jpg';
export { default as Img400 } from './processed/400/Succession-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Succession-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Succession-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Succession-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      161,
      56,
      40
    ],
    "_population": 10,
    "_hsl": [
      0.02203856749311295,
      0.6019900497512438,
      0.3941176470588235
    ]
  },
  "LightVibrant": {
    "_rgb": [
      235,
      200,
      177
    ],
    "_population": 359,
    "_hsl": [
      0.06609195402298852,
      0.5918367346938772,
      0.807843137254902
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      118,
      21,
      15
    ],
    "_population": 66,
    "_hsl": [
      0.009708737864077669,
      0.7744360902255639,
      0.2607843137254902
    ]
  },
  "Muted": {
    "_rgb": [
      171,
      131,
      103
    ],
    "_population": 403,
    "_hsl": [
      0.06862745098039214,
      0.2881355932203389,
      0.5372549019607843
    ]
  },
  "LightMuted": {
    "_rgb": [
      213,
      197,
      176
    ],
    "_population": 71,
    "_hsl": [
      0.09459459459459461,
      0.3057851239669423,
      0.7627450980392156
    ]
  },
  "DarkMuted": {
    "_rgb": [
      76,
      55,
      50
    ],
    "_population": 4073,
    "_hsl": [
      0.032051282051282076,
      0.20634920634920634,
      0.24705882352941178
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Succession-S1.js